import { Gallery } from "./Gallery";

export const Main = () => {
  return (
    <div>
      <main>
        <div>
          <Gallery />
        </div>
      </main>
    </div>
  );
};
